"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkBuilder = linkBuilder;
exports.linkListBuilder = linkListBuilder;
exports.renderLinkFlag = renderLinkFlag;
exports.renderTrayTitle = renderTrayTitle;
exports.setActiveItem = setActiveItem;
exports.trayColumnBuilder = trayColumnBuilder;
exports.trayMenusBuilder = trayMenusBuilder;
exports.urlMatches = urlMatches;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _reactMintl = require("@godaddy/react-mintl");
var _columnLayout = require("@ux/column-layout");
var _trayMenu = require("@ux/tray-menu");
var _golfToEid = _interopRequireDefault(require("golf-to-eid"));
var _text = _interopRequireDefault(require("@ux/text"));
var _react = _interopRequireDefault(require("react"));
var _link = _interopRequireDefault(require("@ux/link"));
var _util = require("@ux/util");
const _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Forces classNames to be an array.
 *
 * @param {Array|String} className Thing to check
 * @returns {Array} Array of classNames
 * @private
 */
function classNames(className) {
  return Array.isArray(className) ? className : [className];
}

/**
 * Ensures that paths have a leading slash.
 *
 * @param {String} pathname Pathname to fix.
 * @returns {String} A correctly formatted path.
 * @private
 */
function normalize(pathname) {
  if (!/^(https?:)?\/\//.test(pathname)) {
    pathname = pathname.charAt(0) === '/' ? pathname : '/' + pathname;
    pathname = pathname.replace('//', '/');
  }
  return pathname;
}

/**
 * Compares two URLs, ignoring any trailing slashes.
 *
 * @param {String} url1 URL to check.
 * @param {String} url2 URL to compare.
 * @param {Boolean} ignoreQueryStrings Whether to ignore query strings.
 * @returns {Boolean} Whether URLs match
 */
function urlMatches(url1, url2) {
  let ignoreQueryStrings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (typeof url1 !== 'string' || typeof url2 !== 'string') {
    return false;
  }
  if (ignoreQueryStrings) {
    url1 = new _util.URL(url1, true).set('query', {}).href;
    url2 = new _util.URL(url2, true).set('query', {}).href;
  }
  return url1.replace(/\/$/, '') === url2.replace(/\/$/, '');
}

/**
 * Sets open or close state of an item.
 *
 * @param {Boolean} open If the item should be open or not
 *
 * @private
 */
function toggleItem(open) {
  this.isOpen = open;
}

/**
 * Construct an anchor tag.
 *
 * @param {Object} opts Link properties.
 * @returns {ReactDOM} Link element for the specified data
 * @public
 */
function linkBuilder(opts) {
  const {
    title,
    id,
    href,
    root = ''
  } = opts;
  if (!title || !href) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({}, opts, {
    href: normalize(root + href),
    "data-eid": id && (0, _golfToEid.default)(id, {
      prefix: opts.eidPrefix,
      postfix: 'link.click'
    })
  }), title && /*#__PURE__*/_react.default.createElement("span", null, title));
}

/**
 * Generate a list of links
 *
 * @param {Array} items The items to generate
 * @param {Object} options Addition configuration for the items.
 * @param {[String]} options.className Array of class names that are all applied to the li
 * @returns {Array} Generated anchor elements.
 * @public
 */
function linkListBuilder() {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
      className
    } = options,
    props = (0, _objectWithoutProperties2.default)(options, _excluded);
  const active = props.active || false;
  return items.map((item, i) => {
    // eslint-disable-line complexity
    const local = classNames(className);
    if (!item.title) return;
    if (active !== false) {
      if (item.id === active || item.title === active || urlMatches(active, item.href)) {
        local.push(props.activeClass || '');
      }
    }
    const onClicked = setActiveItem.bind(null, item.id);
    return /*#__PURE__*/_react.default.createElement("li", {
      key: item.id + i,
      id: item.id,
      className: local.filter(Boolean).join(' ')
    }, linkBuilder(_objectSpread(_objectSpread(_objectSpread({}, item), props), {}, {
      index: i,
      onClicked
    })));
  }).filter(Boolean);
}

/**
 * Generate a column heading and links.
 *
 * @param {Object} item Column item information.
 * @param {Object} [columnClassNames] Object containing classes that can be individually applied
 * @param {Number} [index] Index of the item.
 * @param {Object} [urlArgs] Parameters to be added to item's href upon clicking.
 * @param {Boolean} [suppressTitle] Whether to suppress title.
 * @returns {ReactElement[]} Array of column items
 * @private
 */
function trayColumnBuilder(
// eslint-disable-line max-params
item, columnClassNames, index, urlArgs, suppressTitle) {
  const columnItems = [];
  const classes = columnClassNames || {};
  // push the heading for the column if there is one
  if (!suppressTitle && item.title) {
    columnItems.push( /*#__PURE__*/_react.default.createElement(_text.default.span, {
      as: "title"
    }, /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnItem, {
      key: item.id + index,
      id: item.id
    }, item.title)));
  }
  // then push the links
  if (item.children) {
    for (var i = 0; i < item.children.length; i++) {
      const childItem = item.children[i];
      const onClicked = setActiveItem.bind(null, childItem.id);
      columnItems.push( /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnItem, {
        key: childItem.id + i
      }, linkBuilder(_objectSpread(_objectSpread({
        eidPrefix: 'uxp.hyd.product_nav'
      }, childItem), {}, {
        urlArgs,
        index,
        onClicked
      })), renderLinkFlag(childItem, classes)));
    }
  }
  return columnItems;
}

/**
 * Generate an array of columns.
 *
 * @param {Object} item Column information.
 * @param {Object} classes Object containing classes that can be individually applied
 * @param {Object} urlArgs Parameters to be added to item's href upon clicking.
 * @returns {ReactElement[]} Array of columns or an empty array
 * @private
 */
function trayMenuBuilder(item, classes, urlArgs) {
  if (item.children) {
    const suppressSubcategoryTitle = item.children.length === 1 && item.title && item.children[0].title === item.title;
    return item.children.map((itm, i) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: i
      }, trayColumnBuilder(itm, classes, i, urlArgs, suppressSubcategoryTitle));
    });
  }
  return [];
}

/**
 * Generate TrayTitle text/link when appropriate
 *
 * @param {Object} item The item we are generating the TrayTitle content for.
 * @param {Object} urlArgs Parameters to be added to item's href upon clicking.
 * @returns {Object} TrayTitle content
 * @public
 */
function renderTrayTitle(item, urlArgs) {
  const title = item.title;
  if (item.leftnav && typeof item.leftnav.href === 'string') {
    return /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_link.default, {
      href: item.leftnav.href,
      urlArgs: urlArgs
    }, title));
  }
  return /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, title);
}

/**
 * Generate a list of TrayMenus
 *
 * @param {Array} items The items to generate into trayMenus
 * @param {Object} options Addition configuration for the items.
 * @param {Object} options.classes Object containing classes that can be individually applied
 * @param {[String]} options.className Array of classes that will all be applied to the li
 * @returns {Array} Generated TrayMenus.
 * @public
 */
function trayMenusBuilder() {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const className = classNames(options.className).filter(Boolean).join(' ');
  const classes = options.classes || {};
  const result = [];
  // eslint-disable-next-line complexity
  items.forEach((item, i) => {
    if (item.children && item.children.length > 0) {
      let learnMore, description;

      // remove any children that dont have children
      item.children = item.children.filter(itm => itm.children && itm.children.length > 0);
      if (item.leftnav) {
        if (item.leftnav.description) {
          description = /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
            id: item.leftnav.description
          }));
        } else if (item.leftnav.descriptionText) {
          // Literal pre-translated text
          description = /*#__PURE__*/_react.default.createElement("p", null, item.leftnav.descriptionText);
        }
        if (item.leftnav.btn || item.leftnav.btnText) {
          learnMore = /*#__PURE__*/_react.default.createElement(_link.default, {
            href: item.leftnav.href,
            rel: "nofollow",
            urlArgs: options.urlArgs,
            className: "ux-button ux-button-secondary ux-button-small learn-more",
            "data-eid": (0, _golfToEid.default)(item.leftnav.btn || item.leftnav.btnText, {
              prefix: 'uxp.hyd.product_nav',
              postfix: 'learn_more.click'
            })
          }, item.leftnav.btnText || /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
            id: item.leftnav.btn
          }));
        }
      }
      result.push( /*#__PURE__*/_react.default.createElement("li", {
        id: item.id,
        key: item.id + i,
        className: className
      }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayMenu, {
        name: item.title,
        open: item.isOpen,
        type: "base",
        showOpenCaret: true,
        onToggle: toggleItem.bind(item),
        "data-eid": item.id && (0, _golfToEid.default)(item.id, {
          prefix: 'uxp.hyd.product_nav',
          postfix: 'link.click'
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "product-nav-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "product-nav-row"
      }, renderTrayTitle(item, options.urlArgs)), /*#__PURE__*/_react.default.createElement("div", {
        className: "product-nav-row"
      }, (description || learnMore) && /*#__PURE__*/_react.default.createElement("div", {
        className: "first"
      }, description, learnMore), /*#__PURE__*/_react.default.createElement("div", {
        className: "subnav-columns"
      }, /*#__PURE__*/_react.default.createElement(_columnLayout.Columns, {
        num: item.children.length,
        style: "vertical"
      }, trayMenuBuilder(item, classes, options.urlArgs))))))));
    } else if (item.title) {
      // Render a plain button
      result.push( /*#__PURE__*/_react.default.createElement("li", {
        id: item.id,
        key: item.id + i,
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tray-menu"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tray-toggle-wrapper"
      }, linkBuilder(_objectSpread(_objectSpread({}, item), {}, {
        className: 'tray-toggle topnav-nontray-btn',
        eidPrefix: 'uxp.hyd.product_nav',
        urlArgs: options.urlArgs
      }))))));
    }
  });
  return result;
}
function renderLinkFlag(link, classes) {
  if (!link.options) {
    return;
  }
  const ret = [];
  let i = 0;
  if (link.options.onSale) {
    ret.push(renderLinkFlagInternal(classes.onSale, 'Shared:ProductNav:Flag:OnSale', i++));
  }
  if (link.options.isNew) {
    ret.push(renderLinkFlagInternal(classes.isNew, 'Shared:ProductNav:Flag:New', i++));
  }
  if (link.options.isFree) {
    ret.push(renderLinkFlagInternal(classes.isFree, 'Shared:ProductNav:Flag:TryItFree', i++));
  }
  if (link.options.isPro) {
    ret.push( /*#__PURE__*/_react.default.createElement("span", {
      className: classes.isPro,
      key: i++
    }));
  }
  if (link.options.tout || link.options.toutText) {
    ret.push(renderLinkFlagInternal(classes.tout, link.options.tout || link.options.toutText, i++, !link.options.tout && link.options.toutText));
  }
  return ret;
}
function renderLinkFlagInternal(className, message, key) {
  let messageIsPreTranslated = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return /*#__PURE__*/_react.default.createElement("span", {
    key: key
  }, "\xA0", /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, "-\xA0", messageIsPreTranslated ? /*#__PURE__*/_react.default.createElement("span", null, message) : /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: message
  })));
}

/**
 * Set the localStorage activeCaption value
 * @param {String} caption The caption to assign in localStorage
 * @private
 */
function setActiveItem(caption) {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem('activeCaption', caption);
  }
}